import { useEffect, useState } from "react"
import { Link } from "react-router-dom";
import { Button } from "./ui/button"
import img1 from "../assets/img/7.png";
import img2 from "../assets/img/3.png";
import img3 from "../assets/img/6.png";

const slides = [
  {
    image: img2,
    title: "Acceso instantáneo al stock cercano",
    description:
      "Encuentra bombonas de gas disponibles en tu área al instante con actualizaciones de stock en tiempo real.",
  },
  {
    image: img1,
    title: "3 meses de prueba gratuita",
    description:
      "Obtén acceso completo a todas las funciones incluyendo filtros avanzados durante 3 meses completamente gratis.",
  },
  {
    image: img3,
    title: "Ahorra tiempo y recursos",
    description: "No pierdas el tiempo ni los recursos en busca de bombonas de gas si puedes ver todo desde el móvil.",
  },
]

export function HeroCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, 10000)
    return () => clearInterval(timer)
  }, [])

  return (
    <div className="relative h-[600px] md:h-[700px] overflow-hidden">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover"
          />
          {/* Dark overlay for better text readability */}
          <div className="absolute inset-0 bg-black/50" />
        </div>
      ))}

      {/* Content overlay */}
      <div className="relative h-full flex items-center justify-center">
        <div className="container mx-auto px-4 text-center text-white z-10">
          <div className="max-w-4xl mx-auto space-y-6">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`transition-all duration-700 ${
                  index === currentSlide
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-4 absolute inset-0 pointer-events-none"
                }`}
              >
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 text-balance drop-shadow-lg">
                  {slide.title}
                </h1>
                <p className="text-lg md:text-xl lg:text-2xl mb-8 text-pretty drop-shadow-md max-w-3xl mx-auto">
                  {slide.description}
                </p>
                <Link to="/register">
                  <Button
                    size="lg"
                    className="bg-[#0288d0] hover:bg-[#0288d0]/90 text-white px-8 py-6 text-lg shadow-xl"
                  >
                    Comenzar Prueba Gratuita
                  </Button>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              index === currentSlide ? "bg-white w-8" : "bg-white/50 hover:bg-white/75"
            }`}
            aria-label={`Ir a diapositiva ${index + 1}`}
          />
        ))}
      </div>
    </div>
  )
}